const GradeScaleTypePolicy = {
  GradeScaleValue: {
    keyFields: false,
  },
  GradeScale: {
    keyFields: false,
  },
};

export default GradeScaleTypePolicy;
